import {Partner} from "./Partner";
import {Product} from "./Product";
import {Base} from "./Base";

export enum TransactionType {
    Import = 'IMPORT',
    Export = 'EXPORT',
    Relocation = 'RELOCATION',
}

export interface Transaction extends Base {
    id: string // PK

    type: TransactionType
    partner: Partner
    product: Product
    year: number

    transactionData: JSON
}
